<template>
  <canvas id="canvas"></canvas>
</template>
<script>
export default {
  data() {
    return {
      canvas: null,
      ctx: null,
      brushRadius: null,
      movementPoints: [
        { x: 0, y: 118 },
        { x: 0, y: 116 },
        { x: 0, y: 115 },
        { x: 1, y: 112 },
        { x: 1, y: 111 },
        { x: 2, y: 110 },
        { x: 2, y: 108 },
        { x: 2, y: 106 },
        { x: 3, y: 105 },
        { x: 4, y: 103 },
        { x: 4, y: 101 },
        { x: 5, y: 100 },
        { x: 5, y: 98 },
        { x: 6, y: 97 },
        { x: 6, y: 95 },
        { x: 7, y: 94 },
        { x: 8, y: 91 },
        { x: 8, y: 89 },
        { x: 9, y: 87 },
        { x: 10, y: 86 },
        { x: 10, y: 85 },
        { x: 11, y: 83 },
        { x: 12, y: 82 },
        { x: 12, y: 81 },
        { x: 13, y: 79 },
        { x: 13, y: 78 },
        { x: 13, y: 77 },
        { x: 14, y: 75 },
        { x: 14, y: 74 },
        { x: 14, y: 73 },
        { x: 14, y: 71 },
        { x: 15, y: 70 },
        { x: 15, y: 68 },
        { x: 16, y: 66 },
        { x: 16, y: 64 },
        { x: 17, y: 63 },
        { x: 18, y: 61 },
        { x: 18, y: 60 },
        { x: 19, y: 58 },
        { x: 20, y: 56 },
        { x: 21, y: 54 },
        { x: 21, y: 53 },
        { x: 22, y: 52 },
        { x: 23, y: 50 },
        { x: 24, y: 49 },
        { x: 25, y: 47 },
        { x: 25, y: 45 },
        { x: 26, y: 44 },
        { x: 28, y: 42 },
        { x: 29, y: 40 },
        { x: 30, y: 38 },
        { x: 32, y: 37 },
        { x: 32, y: 36 },
        { x: 33, y: 35 },
        { x: 34, y: 33 },
        { x: 35, y: 32 },
        { x: 36, y: 31 },
        { x: 37, y: 29 },
        { x: 38, y: 28 },
        { x: 38, y: 28 },
        { x: 39, y: 27 },
        { x: 40, y: 26 },
        { x: 40, y: 25 },
        { x: 42, y: 24 },
        { x: 43, y: 22 },
        { x: 43, y: 21 },
        { x: 44, y: 20 },
        { x: 45, y: 20 },
        { x: 46, y: 19 },
        { x: 46, y: 18 },
        { x: 47, y: 17 },
        { x: 48, y: 17 },
        { x: 48, y: 16 },
        { x: 48, y: 16 },
        { x: 49, y: 15 },
        { x: 49, y: 15 },
        { x: 49, y: 16 },
        { x: 49, y: 19 },
        { x: 49, y: 22 },
        { x: 49, y: 25 },
        { x: 49, y: 28 },
        { x: 49, y: 30 },
        { x: 50, y: 33 },
        { x: 50, y: 36 },
        { x: 50, y: 39 },
        { x: 50, y: 41 },
        { x: 50, y: 44 },
        { x: 51, y: 46 },
        { x: 51, y: 48 },
        { x: 51, y: 51 },
        { x: 51, y: 53 },
        { x: 51, y: 55 },
        { x: 51, y: 58 },
        { x: 51, y: 60 },
        { x: 51, y: 63 },
        { x: 51, y: 65 },
        { x: 52, y: 68 },
        { x: 52, y: 70 },
        { x: 52, y: 73 },
        { x: 52, y: 76 },
        { x: 52, y: 80 },
        { x: 52, y: 85 },
        { x: 52, y: 88 },
        { x: 52, y: 92 },
        { x: 53, y: 95 },
        { x: 53, y: 98 },
        { x: 53, y: 101 },
        { x: 53, y: 105 },
        { x: 54, y: 108 },
        { x: 54, y: 112 },
        { x: 54, y: 114 },
        { x: 54, y: 117 },
        { x: 54, y: 120 },
        { x: 54, y: 123 },
        { x: 54, y: 126 },
        { x: 54, y: 129 },
        { x: 54, y: 131 },
        { x: 54, y: 133 },
        { x: 54, y: 134 },
        { x: 54, y: 135 },
        { x: 54, y: 136 },
        { x: 55, y: 136 },
        { x: 56, y: 135 },
        { x: 57, y: 134 },
        { x: 58, y: 132 },
        { x: 59, y: 129 },
        { x: 60, y: 126 },
        { x: 62, y: 122 },
        { x: 64, y: 118 },
        { x: 65, y: 116 },
        { x: 66, y: 112 },
        { x: 68, y: 110 },
        { x: 69, y: 107 },
        { x: 71, y: 104 },
        { x: 72, y: 102 },
        { x: 73, y: 100 },
        { x: 74, y: 98 },
        { x: 74, y: 96 },
        { x: 76, y: 94 },
        { x: 77, y: 91 },
        { x: 78, y: 90 },
        { x: 78, y: 88 },
        { x: 79, y: 86 },
        { x: 80, y: 84 },
        { x: 81, y: 82 },
        { x: 82, y: 80 },
        { x: 83, y: 78 },
        { x: 84, y: 75 },
        { x: 86, y: 73 },
        { x: 88, y: 71 },
        { x: 89, y: 69 },
        { x: 91, y: 66 },
        { x: 93, y: 65 },
        { x: 94, y: 62 },
        { x: 96, y: 61 },
        { x: 98, y: 59 },
        { x: 99, y: 57 },
        { x: 100, y: 56 },
        { x: 101, y: 55 },
        { x: 102, y: 54 },
        { x: 103, y: 52 },
        { x: 104, y: 51 },
        { x: 106, y: 49 },
        { x: 107, y: 48 },
        { x: 108, y: 46 },
        { x: 110, y: 45 },
        { x: 111, y: 44 },
        { x: 112, y: 42 },
        { x: 113, y: 41 },
        { x: 114, y: 41 },
        { x: 114, y: 40 },
        { x: 115, y: 40 },
        { x: 115, y: 40 },
        { x: 116, y: 39 },
        { x: 116, y: 38 },
        { x: 117, y: 38 },
        { x: 117, y: 37 },
        { x: 118, y: 37 },
        { x: 118, y: 37 },
        { x: 118, y: 36 },
        { x: 118, y: 37 },
        { x: 118, y: 40 },
        { x: 118, y: 41 },
        { x: 118, y: 44 },
        { x: 118, y: 47 },
        { x: 118, y: 49 },
        { x: 118, y: 53 },
        { x: 118, y: 56 },
        { x: 118, y: 59 },
        { x: 118, y: 61 },
        { x: 118, y: 64 },
        { x: 118, y: 66 },
        { x: 118, y: 69 },
        { x: 119, y: 70 },
        { x: 119, y: 73 },
        { x: 119, y: 75 },
        { x: 119, y: 77 },
        { x: 119, y: 80 },
        { x: 119, y: 82 },
        { x: 119, y: 85 },
        { x: 119, y: 86 },
        { x: 119, y: 89 },
        { x: 120, y: 90 },
        { x: 120, y: 92 },
        { x: 120, y: 94 },
        { x: 120, y: 96 },
        { x: 120, y: 98 },
        { x: 120, y: 101 },
        { x: 120, y: 102 },
        { x: 120, y: 105 },
        { x: 120, y: 106 },
        { x: 120, y: 109 },
        { x: 121, y: 110 },
        { x: 121, y: 113 },
        { x: 121, y: 115 },
        { x: 121, y: 117 },
        { x: 122, y: 119 },
        { x: 122, y: 121 },
        { x: 122, y: 122 },
        { x: 122, y: 124 },
        { x: 122, y: 126 },
        { x: 122, y: 128 },
        { x: 122, y: 130 },
        { x: 122, y: 131 },
        { x: 122, y: 132 },
        { x: 122, y: 133 },
        { x: 122, y: 134 },
        { x: 122, y: 135 },
        { x: 123, y: 132 },
        { x: 124, y: 129 },
        { x: 125, y: 125 },
        { x: 127, y: 122 },
        { x: 128, y: 118 },
        { x: 130, y: 114 },
        { x: 131, y: 110 },
        { x: 133, y: 105 },
        { x: 134, y: 102 },
        { x: 136, y: 98 },
        { x: 138, y: 94 },
        { x: 139, y: 91 },
        { x: 141, y: 88 },
        { x: 142, y: 86 },
        { x: 143, y: 83 },
        { x: 145, y: 81 },
        { x: 146, y: 79 },
        { x: 148, y: 76 },
        { x: 149, y: 74 },
        { x: 151, y: 71 },
        { x: 152, y: 69 },
        { x: 154, y: 67 },
        { x: 155, y: 65 },
        { x: 157, y: 63 },
        { x: 159, y: 60 },
        { x: 161, y: 57 },
        { x: 163, y: 55 },
        { x: 166, y: 53 },
        { x: 168, y: 50 },
        { x: 171, y: 48 },
        { x: 174, y: 44 },
        { x: 176, y: 41 },
        { x: 179, y: 39 },
        { x: 180, y: 38 },
        { x: 181, y: 37 },
        { x: 182, y: 35 },
        { x: 183, y: 35 },
        { x: 183, y: 34 },
        { x: 184, y: 34 },
        { x: 184, y: 33 },
        { x: 184, y: 33 },
        { x: 185, y: 33 },
        { x: 185, y: 32 },
        { x: 185, y: 34 },
        { x: 185, y: 37 },
        { x: 185, y: 40 },
        { x: 186, y: 44 },
        { x: 186, y: 47 },
        { x: 186, y: 50 },
        { x: 186, y: 54 },
        { x: 187, y: 57 },
        { x: 187, y: 60 },
        { x: 188, y: 64 },
        { x: 188, y: 66 },
        { x: 188, y: 70 },
        { x: 189, y: 74 },
        { x: 189, y: 78 },
        { x: 190, y: 82 },
        { x: 190, y: 86 },
        { x: 191, y: 90 },
        { x: 191, y: 93 },
        { x: 192, y: 95 },
        { x: 192, y: 97 },
        { x: 193, y: 99 },
        { x: 193, y: 102 },
        { x: 194, y: 105 },
        { x: 194, y: 108 },
        { x: 195, y: 110 },
        { x: 196, y: 113 },
        { x: 196, y: 115 },
        { x: 196, y: 118 },
        { x: 196, y: 119 },
        { x: 197, y: 121 },
        { x: 197, y: 121 },
        { x: 199, y: 119 },
        { x: 201, y: 117 },
        { x: 203, y: 114 },
        { x: 205, y: 112 },
        { x: 206, y: 109 },
        { x: 208, y: 107 },
        { x: 208, y: 107 },
        { x: 209, y: 106 },
        { x: 210, y: 104 },
        { x: 211, y: 103 },
        { x: 213, y: 101 },
        { x: 214, y: 99 },
        { x: 217, y: 96 },
        { x: 221, y: 93 },
        { x: 224, y: 89 },
        { x: 228, y: 86 },
        { x: 233, y: 80 },
        { x: 238, y: 75 },
        { x: 243, y: 71 },
        { x: 248, y: 67 },
        { x: 252, y: 64 },
        { x: 254, y: 61 },
        { x: 258, y: 58 },
        { x: 260, y: 57 },
        { x: 262, y: 54 },
        { x: 264, y: 53 },
        { x: 266, y: 51 },
        { x: 268, y: 49 },
        { x: 270, y: 48 },
        { x: 271, y: 47 },
        { x: 273, y: 46 },
        { x: 274, y: 44 },
        { x: 276, y: 43 },
        { x: 278, y: 42 },
        { x: 281, y: 40 },
        { x: 284, y: 38 },
        { x: 287, y: 36 },
        { x: 289, y: 34 },
        { x: 292, y: 33 },
        { x: 293, y: 32 },
        { x: 294, y: 32 },
        { x: 295, y: 31 },
        { x: 296, y: 30 },
        { x: 296, y: 30 },
        { x: 296, y: 30 },
        { x: 295, y: 30 },
        { x: 295, y: 7 },
      ],
    };
  },
  methods: {
    canvasPreProcessing() {
      this.canvas = document.getElementById("canvas");
      this.ctx = this.canvas.getContext("2d");
      this.ctx.rect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.fillStyle = "#161616f5";
      this.ctx.fill();
    },
    getBrushPos(xRef, yRef) {
      var canvasRect = this.canvas.getBoundingClientRect();
      return {
        x: Math.floor(
          ((xRef - canvasRect.left) / (canvasRect.right - canvasRect.left)) *
            this.canvas.width
        ),
        y: Math.floor(
          ((yRef - canvasRect.top) / (canvasRect.bottom - canvasRect.top)) *
            this.canvas.height
        ),
      };
    },

    onMouseMove(e) {
      var brushPos = this.getBrushPos(e.clientX, e.clientY);
      this.movementPoints.push({ x: brushPos.x, y: brushPos.y });
      this.drawDot(brushPos.x, brushPos.y);
    },
    brushAway(x, y) {
      this.ctx.arc(x, y, 50, 0, 2 * Math.PI, true);
      this.ctx.fill();
    },
  },
  mounted() {
    this.canvasPreProcessing();
    this.ctx.globalCompositeOperation = "destination-out";
    this.ctx.beginPath();
    setTimeout(() => {
      var interval = setInterval(() => {
        var { x, y } = this.movementPoints.shift();
        this.brushAway(x, y);
        if (this.movementPoints.length == 0) {
          clearInterval(interval);
        }
      }, 8);
    }, 1500);
    this.ctx.closePath();
  },
};
</script>
<style lang="scss" scoped>
#canvas {
  z-index: 2;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 300px;
}
</style>
